<script setup lang="ts">
import { UserAvatar, type User } from '#shared'

const { user, isFocused } = defineProps<{ user: User; isFocused: boolean }>()

const emit = defineEmits<{ hover: []; complete: [login: string] }>()

const onMouseEnter = () => emit('hover')

const onClick = () => emit('complete', user.login)
</script>

<template>
  <li :style="$style.root">
    <button :class="[$style.button, { [$style.buttonFocused]: isFocused }]" @mouseenter="onMouseEnter" @click="onClick">
      <UserAvatar :user="user" size="tiny" />
      <span :style="$style.displayName">{{ user.displayName }}</span>
    </button>
  </li>
</template>

<style lang="scss" module>
@use '../mixins.scss' as *;
@use '#mixins/media' as media;

.root {
  display: flex;
}

.button {
  @include message-editor-padding;

  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 5px;
  padding-bottom: 5px;
  width: 100%;

  &:hover {
    background-color: #1a1920;
  }

  @include media.mobile {
    @include message-editor-padding-mobile;
  }
}

.buttonFocused {
  background-color: #1a1920;
}
</style>
